/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Card, Tab, Tabs } from "react-bootstrap";
import { useParams } from "react-router-dom";

import ITRFilingApi from "../../../api/ITRFilingApi";
import { EToastvariant, IFilingFilters, ITRFilingParams } from "../../../config/interfaces";
import { useAppDispatch, useAppSelector } from "../../../redux/Store";
import { filingFiltersSelector, setFilingFilters } from "../../../redux/slice/FilterSlice";
import { showToastMsg } from "../../../redux/slice/ToastMsgSlice";
import { UtilService } from "../../../services";
import PageFilterWrap from "../../PageFilterWrap";
import { FilingTableHeadings } from "../../TableHeaders";
import { CardLoader } from "../../content-loader";
import { ITRFilingsTable } from "../../tables";

let INIT_FILTER_VALUES: IFilingFilters = {
  q: "",
  orderBy: "createdAt",
  order: "DESC",
  rowCount: 10
};

type Props = {};

const AdminExpertFilings: React.FC<Props> = (props: Props) => {
  const dispatch = useAppDispatch();
  const { uUId } = useParams();

  const filingFilters = useAppSelector(filingFiltersSelector);

  const [filings, setFilings] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isPageLoaded, setIsPageLoaded] = useState<boolean>(false);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>(
    filingFilters?.q || INIT_FILTER_VALUES?.q || ""
  );
  const [activeTab, setActiveTab] = useState<"self" | "assisted">("assisted");
  /* TODO it would be removed if we are not going to show filters in url as url params and use filingFiltersSelector */
  const [filterValues, setFilterValues] = useState<IFilingFilters>(() => {
    // on load set filter values
    INIT_FILTER_VALUES = {
      ...INIT_FILTER_VALUES
    };
    // set filter values if exists (navigate back), otherwise init values
    return filingFilters || INIT_FILTER_VALUES;
  });
  // page index will start from 0 for pagination, and will be inc by 1 in api call
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(0);
  const [currentTimeStamp, setCurrentTimeStamp] = useState<number>(new Date().getTime());
  const [pageCount, setPageCount] = useState(0);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    getAllFilings();
  }, [currentTimeStamp, activeTab]);

  const getAllFilings = async () => {
    try {
      if (!uUId) {
        return;
      }
      setIsLoading(currentPageIndex === 0 && !isPageLoaded);
      setIsFetching(true);

      const _params: ITRFilingParams = {
        search: filterValues.q,
        offset: offset,
        count: filterValues.rowCount,
        orderBy: filterValues.orderBy,
        order: filterValues.order,
        userUuid: uUId,
        authorized: undefined
      };

      if (activeTab === "assisted") {
        _params.authorized = true;
      }

      const filingsApi = ITRFilingApi.getInstance();
      const { records, count } = await filingsApi.getITRFilings(_params);

      setFilings(() => records);
      setPageCount(Math.ceil(Number(count / 10)));
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    } finally {
      setIsPageLoaded(true);
      setIsLoading(false);
      setIsFetching(false);
    }
  };

  const handleOnPageChange = (event: any) => {
    if (event.selected > 0) {
      setOffset(event.selected * 10);
    } else {
      setOffset(0);
    }
    setCurrentPageIndex(Math.ceil(event.selected));
    setCurrentTimeStamp(new Date().getTime());
  };

  const handleSearchQuery = () => {
    const _values = {
      ...filterValues,
      q: searchQuery
    };
    setFilterValues(() => _values);
    dispatch(setFilingFilters(_values));
    setCurrentPageIndex(0);
    setCurrentTimeStamp(new Date().getTime());
  };

  return (
    <div className="bg-white pt-4">
      {isLoading ? (
        <>
          <CardLoader cardType="list" />
        </>
      ) : (
        <Card className="table-card">
          <Card.Header className="border-0">
            <PageFilterWrap
              filtersForm={<></>}
              showSearchFilter={true}
              searchPlaceholder="Search by Name or PAN"
              searchValue={searchQuery}
              searchOnChange={(_query) => {
                setSearchQuery(_query);
              }}
              onClickSearchBtn={handleSearchQuery}
              showAdvFilters={false}
            />
          </Card.Header>
          <Card.Body>
            <Tabs
              activeKey={activeTab}
              id="efiling-tabs"
              className="border-nav-tabs compact-tabs my-0"
              onSelect={(key) => {
                switch (key) {
                  case "assisted":
                    setActiveTab("assisted");
                    break;
                  case "self":
                    setActiveTab("self");
                    break;
                }
              }}
            >
              <Tab eventKey="assisted" title="Assisted">
                {isFetching ? (
                  <CardLoader cardType="list" />
                ) : (
                  <>
                    <ITRFilingsTable
                      filingsData={filings}
                      pageCount={pageCount}
                      forcePage={currentPageIndex}
                      handleOnPageChange={handleOnPageChange}
                      noRecords={!filings.length}
                      handleRefresh={() => setCurrentTimeStamp(new Date().getTime())}
                      hideColumns={[
                        FilingTableHeadings[1].title,
                        FilingTableHeadings[3].title,
                        FilingTableHeadings[6].title
                      ]}
                    />
                  </>
                )}
              </Tab>
              <Tab eventKey="self" title="Self">
                {isFetching ? (
                  <CardLoader cardType="list" />
                ) : (
                  <>
                    <ITRFilingsTable
                      filingsData={filings}
                      pageCount={pageCount}
                      forcePage={currentPageIndex}
                      handleOnPageChange={handleOnPageChange}
                      noRecords={!filings.length}
                      handleRefresh={() => setCurrentTimeStamp(new Date().getTime())}
                      hideColumns={[FilingTableHeadings[1].title, FilingTableHeadings[6].title]}
                    />
                  </>
                )}
              </Tab>
            </Tabs>
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default AdminExpertFilings;
